<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SymDof/CoverDesign.jpg?1685327487500" alt="This image is the cover for the book Fixer-Upper"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fixer-Upper
      </h1>
      <p class="bookDescription body article font2">
        <p>Ex-business owner and soon to be ex-husband Jake has had some rotten luck of late. His world is tumbling down around him, but it’s time to dust himself off and move on. Buying and fixing up the most dilapidated home he can find might be just the thing to get him back on track.</p> <p>But Jake gets more than he bargained for when he meets former lawyer turned landscaper Dakota. Dakota is smart and ridiculously sexy—and Jake doesn't have a clue how to act around him. After several gardening mishaps, Jake is sure Dakota thinks he’s completely inept.</p> <p>Turns out Dakota is thinking something else entirely. And as Dakota gives Jake advice, an ear to listen, and helps him work through his issues, Jake realizes flowers aren’t the only thing blooming between them.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meg Harding
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c6c624e